import { hydrateRequestFromApi, stripFolderIdForPayload } from './collectionFolders';
import { normalizeRequestBodyMode } from './requestBodyMode';
import { normalizeMock, normalizeRequestKind } from './workspaceTabPersistence';
import { defaultRequestAuth } from './requestAuth';
import { protocolFieldsOf, settingsWithoutProtocol } from './requestProtocolFields';


/** Map an API request record to the sidebar/editor shape. Pure. */
export function mapApiRequestToSidebar(apiRequest) {
  const hydrated = hydrateRequestFromApi(apiRequest);
  const body_type = hydrated.body_type || 'json';
  const bodyMode = normalizeRequestBodyMode({
    bodyType: body_type,
    settings: hydrated.settings,
  });
  return {
    id: hydrated.id,
    name: hydrated.name,
    method: hydrated.method,
    url: hydrated.url,
    headers: hydrated.headers || [],
    params: hydrated.params || [],
    cookies: hydrated.cookies || [],
    body: hydrated.body || '',
    bodyType: bodyMode.bodyType,
    rawBodyLanguage: bodyMode.rawBodyLanguage,
    body_type,
    formDataFields: hydrated.formDataFields,
    auth: hydrated.auth || {},
    description: hydrated.description || '',
    sort_order: hydrated.sort_order || 0,
    folder_id: hydrated.folder_id || null,
    // the cloud copy of the gRPC / WebSocket fields is unpacked above; keeping it here would go stale
    settings: settingsWithoutProtocol(hydrated.settings),
    can_edit: hydrated.can_edit,
    owner: hydrated.owner,
    preRequestScript: hydrated.preRequestScript ?? '',
    testScript: hydrated.testScript ?? '',
    mock: normalizeMock(hydrated.mock),
    type: normalizeRequestKind(hydrated.type),
    // gRPC / WebSocket fields (card 5258c71d) — this list dropped them like the save did.
    ...protocolFieldsOf({ ...hydrated, type: normalizeRequestKind(hydrated.type) }),
  };
}

/** Map an imported (e.g. OpenAPI/Bruno) request to a local-only request. Pure. */
export function mapImportedRequestToLocal(req, idPrefix, index) {
  const { settings, folder_id } = stripFolderIdForPayload({
    ...req,
    bodyType: req.body_type,
    formDataFields: req.settings?.form_data_fields,
  });
  return {
    id: `${idPrefix}-req-${index}`,
    name: req.name,
    description: req.description || '',
    method: req.method || 'GET',
    url: req.url || '',
    headers: req.headers || [],
    params: req.params || [],
    cookies: req.cookies || [],
    body: req.body || '',
    bodyType: req.body_type || req.bodyType || 'json',
    body_type: req.body_type || req.bodyType || 'json',
    auth: req.auth || defaultRequestAuth(),
    // Preserve imported pre-request/test scripts so Postman/Insomnia/Bruno tests
    // survive the transition (the runner reads these fields directly).
    preRequestScript: req.preRequestScript ?? '',
    testScript: req.testScript ?? '',
    ...(req.protocolProfileBehavior ? { protocolProfileBehavior: req.protocolProfileBehavior } : {}),
    ...(req.mock ? { mock: normalizeMock(req.mock) } : {}),
    type: normalizeRequestKind(req.type),
    sort_order: req.sort_order ?? index,
    folder_id,
    settings,
  };
}
